import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';

const Screen: FC = () => {
  return <MainLayout title="Редактиране на пакет с документи">редактиране</MainLayout>;
};

export default Screen;
